import {useRef} from 'react';
import useIsomorphicEffect from 'src/internal/useIsomorphicEffect';

/**
 *
 * @see https://trailhead.corp.stripe.com/docs/sail-ui/api/react/useUpdateEffect
 */
export default function useUpdateEffect(
  /** The callback to execute when a change is detected. */
  callback: () => void,
  /** The list of dependencies to monitor for changes. */
  deps: unknown[],
): void {
  const init = useRef(false);

  useIsomorphicEffect(() => {
    if (init.current) {
      callback();
    }
    init.current = true;
  }, deps);
}
